export enum RangeEnum {
	Today = 0,
	Tomorrow = 1,
	ThisWeekend = 2,
	ThisWeek = 3,
	ThisMonth = 4,
	All = 5,
	Custom = 6,
}
